(function() {
  'use strict';

  var PAWTY_TOYS = [
    '1996 Tequila',
    '3 In 1 Birthday Cupcake',
    '420 Weed Canister',
    '888 Tequila',
    'Avocado',
    'Barkin Bag',
    'Barky Balls',
    'Barky Balls Large',
    'Barky Balls Medium',
    'Birthday Balloon',
    'Birthday Bone - Pink',
    'Birthday Bone Blue - Rubber (Latex)',
    'Birthday Bone — White/Blue',
    'Birthday Cake Blue',
    'Birthday Cake — PINK',
    'Bong',
    'Bored Ape',
    'Boxing Glove',
    'Brown Bone',
    'Candy',
    'Carrot',
    'Cash Is King',
    'Champagne',
    'Cheese',
    'Chewnel',
    'Chewnel Bone',
    'Chewpotle Bowl',
    'Chewy Pawtton',
    'Chewy Pawtton Bone',
    'Christmas Sock',
    'Claws Awoof',
    'Claws Awoof Rubber',
    'Claws Mini',
    'Coffee',
    'Corn',
    'Cupcake — Blue',
    'Cupcake — Pink',
    'Dogior Blue Bag',
    'Dogior Bone',
    'Donald',
    'Donut Set',
    'Duck',
    'Dumbbell',
    'Eggplant',
    'Fireworks',
    'Football',
    'Furji Water',
    'Golf Bag',
    'Golf Set Hole In One',
    'Gotcha Day Bone',
    'Hair Dryer',
    'Hammer',
    'Ice Cream',
    'Joint - Snuffle Mat',
    'Joint - Treat Slot',
    'Kettlebell',
    'Lamb',
    'Lipstick',
    'Love Bone',
    'Love Heart',
    'Meat Stick',
    'Nunchucks',
    'PAW Pouch',
    'PAWTY Beer',
    'PAWTY Boba',
    'PAWTY Bone — Blue/Yellow',
    'PAWTY Bone — Pink/Green',
    'PAWTY Express Chinese Takeout Box',
    'PAWTY Fried Chicken',
    'PAWTY Hydration Bottle',
    'PAWTY Water',
    'Paw-er Drill',
    'Paw-rat (Borat)',
    'Pawfume',
    'Pawsolut Vodka',
    'Pawtato Chips',
    'Pawtein Bar',
    'Pawsla Doge',
    'Pea Pod',
    'Peelable Banana',
    'Pickleball Set',
    'Pretzel & Baguette Set',
    'Red Envelope',
    'Rose',
    'Sandals',
    'Sausage',
    'Slow Feeder Dog Bowl Set',
    'Smirruff Ice',
    'Sneakers',
    'Soju',
    'Sports Balls (Set Of 2)',
    'Steak',
    'Sushi Set',
    'Tape Measurer',
    'Toy Basket',
    'Trophy',
    'Turkey',
    'Unicorn'
  ];

  var DROPDOWN_INJECTED = false;

  function setNativeValue(input, value) {
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function injectDropdown(textInput) {
    if (DROPDOWN_INJECTED) return;
    DROPDOWN_INJECTED = true;

    var select = document.createElement('select');
    select.className = textInput.className;

    var cs = window.getComputedStyle(textInput);
    select.style.cssText = [
      'width:100%',
      'height:' + cs.height,
      'padding:' + cs.padding,
      'border:' + cs.border,
      'border-radius:' + cs.borderRadius,
      "font-family:'DM Sans', sans-serif !important",
      'font-size:' + cs.fontSize,
      'color:' + cs.color,
      'background-color:' + cs.backgroundColor,
      'appearance:auto',
      '-webkit-appearance:auto',
      'cursor:pointer',
      'box-sizing:border-box'
    ].join(';');

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select your toy';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);

    PAWTY_TOYS.forEach(function(toy) {
      var opt = document.createElement('option');
      opt.value = toy;
      opt.textContent = toy;
      select.appendChild(opt);
    });

    var otherOpt = document.createElement('option');
    otherOpt.value = '__other__';
    otherOpt.textContent = 'Other (not listed)';
    select.appendChild(otherOpt);

    textInput.style.display = 'none';
    textInput.parentNode.insertBefore(select, textInput.nextSibling);

    select.addEventListener('change', function() {
      if (select.value === '__other__') {
        select.style.display = 'none';
        textInput.style.display = '';
        textInput.placeholder = 'Type your toy name';
        textInput.focus();
      } else {
        setNativeValue(textInput, select.value);
      }
    });
  }

  function scanForToyInput() {
    if (DROPDOWN_INJECTED) return;
    var inputs = document.querySelectorAll('input[type="text"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.id && inp.id.indexOf('registered_toy') === 0) {
        injectDropdown(inp);
        return;
      }
    }
  }

  var observer = new MutationObserver(function() {
    if (!DROPDOWN_INJECTED) scanForToyInput();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  scanForToyInput();
})();
